// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   InfoValidateReset — versión tooltip (sin overlay)
   ═══════════════════════════════════════════════ */
.ivr-wrap {
  width: 280px;
  border-radius: 10px;
  overflow: hidden;
  font-family: sans-serif;
  font-size: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  /* El tooltiptext del padre ya maneja el posicionamiento */
}
.tooltiptab.contEventsActions .tooltiptext {
  width: 300px;
  background-color: transparent;
  border: none;
  padding: 0;
  text-align: left;
  border-radius: 0;
  margin-left: -150px;
  overflow: visible;
}

/* ── Header ─────────────────────────────────────── */
.ivr-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
}
.ivr-header--ok   { background: #EAF3DE; }
.ivr-header--warn { background: #FAEEDA; }

.ivr-header-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}
.ivr-header--ok   .ivr-header-icon { background: #3B6D11; }
.ivr-header--warn .ivr-header-icon { background: #BA7517; }

.ivr-header-title {
  font-size: 12px;
  font-weight: 500;
  margin: 0 0 2px;
}
.ivr-header--ok   .ivr-header-title { color: #27500A; }
.ivr-header--warn .ivr-header-title { color: #633806; }

.ivr-header-sub {
  font-size: 11px;
  margin: 0;
  line-height: 1.3;
}
.ivr-header--ok   .ivr-header-sub { color: #3B6D11; }
.ivr-header--warn .ivr-header-sub { color: #854F0B; }

/* ── Body ────────────────────────────────────────── */
.ivr-body {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #fff;
}

/* ── Item ────────────────────────────────────────── */
.ivr-item {
  display: flex;
  gap: 8px;
  border-radius: 8px;
  padding: 8px 10px;
  border: 0.5px solid transparent;
}
.ivr-item--ok   { background: #EAF3DE; border-color: #C0DD97; }
.ivr-item--fail { background: #FCEBEB; border-color: #F7C1C1; }

.ivr-item-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  margin-top: 1px;
}
.ivr-item--ok   .ivr-item-icon { background: #3B6D11; }
.ivr-item--fail .ivr-item-icon { background: #A32D2D; }

.ivr-item-content { flex: 1 1; }

.ivr-item-title {
  font-size: 11px;
  font-weight: 500;
  margin: 0 0 3px;
}
.ivr-item--ok   .ivr-item-title { color: #27500A; }
.ivr-item--fail .ivr-item-title { color: #791F1F; }

.ivr-item-desc {
  font-size: 11px;
  margin: 0 0 5px;
  line-height: 1.3;
}
.ivr-item--ok   .ivr-item-desc { color: #3B6D11; margin-bottom: 0; }
.ivr-item--fail .ivr-item-desc { color: #A32D2D; }

/* ── Pasos ───────────────────────────────────────── */
.ivr-steps {
  margin: 0;
  padding-left: 14px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ivr-steps li {
  font-size: 11px;
  color: #791F1F;
  line-height: 1.4;
}
.ivr-steps li strong {
  color: #501313;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/modals-monitoreo/styles/ResetInfo.css"],"names":[],"mappings":"AAAA;;oDAEoD;AACpD;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,0DAA0D;AAC5D;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,sCAAsC,cAAc,EAAE;AACtD,sCAAsC,cAAc,EAAE;;AAEtD;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA,oCAAoC,cAAc,EAAE;AACpD,oCAAoC,cAAc,EAAE;;AAEpD,uDAAuD;AACvD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;AACA,kBAAkB,mBAAmB,EAAE,qBAAqB,EAAE;AAC9D,kBAAkB,mBAAmB,EAAE,qBAAqB,EAAE;;AAE9D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;;AAEtD,oBAAoB,SAAO,EAAE;;AAE7B;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;;AAElD;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,iCAAiC,cAAc,EAAE,gBAAgB,EAAE;AACnE,iCAAiC,cAAc,EAAE;;AAEjD,uDAAuD;AACvD;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* ═══════════════════════════════════════════════\r\n   InfoValidateReset — versión tooltip (sin overlay)\r\n   ═══════════════════════════════════════════════ */\r\n.ivr-wrap {\r\n  width: 280px;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  font-family: sans-serif;\r\n  font-size: 12px;\r\n  background: #ffffff;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n  /* El tooltiptext del padre ya maneja el posicionamiento */\r\n}\r\n.tooltiptab.contEventsActions .tooltiptext {\r\n  width: 300px;\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  text-align: left;\r\n  border-radius: 0;\r\n  margin-left: -150px;\r\n  overflow: visible;\r\n}\r\n\r\n/* ── Header ─────────────────────────────────────── */\r\n.ivr-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px 12px;\r\n}\r\n.ivr-header--ok   { background: #EAF3DE; }\r\n.ivr-header--warn { background: #FAEEDA; }\r\n\r\n.ivr-header-icon {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  color: #fff;\r\n}\r\n.ivr-header--ok   .ivr-header-icon { background: #3B6D11; }\r\n.ivr-header--warn .ivr-header-icon { background: #BA7517; }\r\n\r\n.ivr-header-title {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin: 0 0 2px;\r\n}\r\n.ivr-header--ok   .ivr-header-title { color: #27500A; }\r\n.ivr-header--warn .ivr-header-title { color: #633806; }\r\n\r\n.ivr-header-sub {\r\n  font-size: 11px;\r\n  margin: 0;\r\n  line-height: 1.3;\r\n}\r\n.ivr-header--ok   .ivr-header-sub { color: #3B6D11; }\r\n.ivr-header--warn .ivr-header-sub { color: #854F0B; }\r\n\r\n/* ── Body ────────────────────────────────────────── */\r\n.ivr-body {\r\n  padding: 8px 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  background: #fff;\r\n}\r\n\r\n/* ── Item ────────────────────────────────────────── */\r\n.ivr-item {\r\n  display: flex;\r\n  gap: 8px;\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n  border: 0.5px solid transparent;\r\n}\r\n.ivr-item--ok   { background: #EAF3DE; border-color: #C0DD97; }\r\n.ivr-item--fail { background: #FCEBEB; border-color: #F7C1C1; }\r\n\r\n.ivr-item-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  color: #fff;\r\n  margin-top: 1px;\r\n}\r\n.ivr-item--ok   .ivr-item-icon { background: #3B6D11; }\r\n.ivr-item--fail .ivr-item-icon { background: #A32D2D; }\r\n\r\n.ivr-item-content { flex: 1; }\r\n\r\n.ivr-item-title {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  margin: 0 0 3px;\r\n}\r\n.ivr-item--ok   .ivr-item-title { color: #27500A; }\r\n.ivr-item--fail .ivr-item-title { color: #791F1F; }\r\n\r\n.ivr-item-desc {\r\n  font-size: 11px;\r\n  margin: 0 0 5px;\r\n  line-height: 1.3;\r\n}\r\n.ivr-item--ok   .ivr-item-desc { color: #3B6D11; margin-bottom: 0; }\r\n.ivr-item--fail .ivr-item-desc { color: #A32D2D; }\r\n\r\n/* ── Pasos ───────────────────────────────────────── */\r\n.ivr-steps {\r\n  margin: 0;\r\n  padding-left: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n.ivr-steps li {\r\n  font-size: 11px;\r\n  color: #791F1F;\r\n  line-height: 1.4;\r\n}\r\n.ivr-steps li strong {\r\n  color: #501313;\r\n  font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
